import { render, staticRenderFns } from "./EditTicketDiscountModal.vue?vue&type=template&id=00512fc1&scoped=true"
import script from "./EditTicketDiscountModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTicketDiscountModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditTicketDiscountModal.vue?vue&type=style&index=0&id=00512fc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00512fc1",
  null
  
)

export default component.exports